export const containsNoAlphabets = (str: string) => {
  return !/[a-zA-Z]/.test(str);
};
